import { render } from "./usuarios.vue?vue&type=template&id=b7eb961c"
import script from "./usuarios.vue?vue&type=script&lang=js"
export * from "./usuarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__